 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"index": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"pages-activities-invite":"pages-activities-invite","pages-address-add":"pages-address-add","pages-address-address":"pages-address-address","pages-attendance-attendance":"pages-attendance-attendance","pages-balance-balance":"pages-balance-balance","pages-common-feedback-feedback~pages-login-login~pages-meal-time-meal-time~pages-menu-menu~pages-men~2c0260e0":"pages-common-feedback-feedback~pages-login-login~pages-meal-time-meal-time~pages-menu-menu~pages-men~2c0260e0","pages-common-feedback-feedback~pages-meal-time-meal-time~pages-menu-menu~pages-menu-menu-advance~pag~ec5b1abb":"pages-common-feedback-feedback~pages-meal-time-meal-time~pages-menu-menu~pages-menu-menu-advance~pag~ec5b1abb","pages-common-feedback-feedback~pages-mine-userinfo":"pages-common-feedback-feedback~pages-mine-userinfo","pages-common-feedback-feedback":"pages-common-feedback-feedback","pages-meal-time-meal-time":"pages-meal-time-meal-time","pages-menu-menu~pages-menu-menu-advance":"pages-menu-menu~pages-menu-menu-advance","pages-menu-menu":"pages-menu-menu","pages-menu-menu-advance":"pages-menu-menu-advance","pages-user-management-user-management":"pages-user-management-user-management","pages-mine-userinfo":"pages-mine-userinfo","pages-login-login":"pages-login-login","pages-orders-detail~pages-qr-qr~pages-receipt-receipt":"pages-orders-detail~pages-qr-qr~pages-receipt-receipt","pages-orders-detail":"pages-orders-detail","pages-receipt-receipt":"pages-receipt-receipt","pages-pay-pay":"pages-pay-pay","pages-report-statistics-report-statistics":"pages-report-statistics-report-statistics","pages-common-feedbackDetail-feedbackDetail":"pages-common-feedbackDetail-feedbackDetail","pages-common-feedbackIndex-feedbackIndex":"pages-common-feedbackIndex-feedbackIndex","pages-common-feedbackList-feedbackList":"pages-common-feedbackList-feedbackList","pages-common-helpDetail-helpDetail":"pages-common-helpDetail-helpDetail","pages-common-showImage-showImage":"pages-common-showImage-showImage","pages-coupons-coupons":"pages-coupons-coupons","pages-dashboard-dashboard":"pages-dashboard-dashboard","pages-giftcard-giftcard":"pages-giftcard-giftcard","pages-integrals-detail":"pages-integrals-detail","pages-integrals-flow":"pages-integrals-flow","pages-integrals-integrals":"pages-integrals-integrals","pages-invoice-invoice":"pages-invoice-invoice","pages-mine-member-code":"pages-mine-member-code","pages-mine-mine":"pages-mine-mine","pages-order-details-order-details":"pages-order-details-order-details","pages-qr-qr":"pages-qr-qr","pages-orders-orders":"pages-orders-orders","pages-packages-detail":"pages-packages-detail","pages-packages-index":"pages-packages-index","pages-remark-remark":"pages-remark-remark","pages-review-review":"pages-review-review","pages-services-help-center":"pages-services-help-center","pages-services-services":"pages-services-services","pages-take-foods-take-foods":"pages-take-foods-take-foods"}[chunkId]||chunkId) + "." + {"pages-activities-invite":"09e15efd","pages-address-add":"b1b7a640","pages-address-address":"8f426997","pages-attendance-attendance":"7ad359ea","pages-balance-balance":"5918bbab","pages-common-feedback-feedback~pages-login-login~pages-meal-time-meal-time~pages-menu-menu~pages-men~2c0260e0":"ca31d2fb","pages-common-feedback-feedback~pages-meal-time-meal-time~pages-menu-menu~pages-menu-menu-advance~pag~ec5b1abb":"53f8aae5","pages-common-feedback-feedback~pages-mine-userinfo":"d02ee080","pages-common-feedback-feedback":"3cd532bf","pages-meal-time-meal-time":"189b86d6","pages-menu-menu~pages-menu-menu-advance":"82427302","pages-menu-menu":"7130645d","pages-menu-menu-advance":"e64f6892","pages-user-management-user-management":"406948ae","pages-mine-userinfo":"7731efa4","pages-login-login":"afa88ddb","pages-orders-detail~pages-qr-qr~pages-receipt-receipt":"036d822d","pages-orders-detail":"02846053","pages-receipt-receipt":"30fe9884","pages-pay-pay":"cb942574","pages-report-statistics-report-statistics":"3cc9d1a3","pages-common-feedbackDetail-feedbackDetail":"183a4953","pages-common-feedbackIndex-feedbackIndex":"446a2493","pages-common-feedbackList-feedbackList":"bd0ef95f","pages-common-helpDetail-helpDetail":"3d116905","pages-common-showImage-showImage":"2e980ced","pages-coupons-coupons":"22897abc","pages-dashboard-dashboard":"eccf7e9f","pages-giftcard-giftcard":"a6273eef","pages-integrals-detail":"6bf33f05","pages-integrals-flow":"0dc03084","pages-integrals-integrals":"80c075e4","pages-invoice-invoice":"7130d5c0","pages-mine-member-code":"2df02ed2","pages-mine-mine":"8dc73ac8","pages-order-details-order-details":"ebe4f27a","pages-qr-qr":"2ab6057b","pages-orders-orders":"a7ae4591","pages-packages-detail":"d7ba6e94","pages-packages-index":"01d6d8e2","pages-remark-remark":"902c4342","pages-review-review":"f8a99fcd","pages-services-help-center":"7baf36a0","pages-services-services":"eac28bb0","pages-take-foods-take-foods":"2db4126b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
